<template>
  <div class="switches">
    <h2 class="mb-2 primary--text">SWITCHES</h2>
    <v-form>
      <v-row>
        <!-- <v-col cols="12">
          <v-btn depressed color="primary" @click="editSwitch(null)"><v-icon class="mr-2">mdi-plus</v-icon> Add new</v-btn>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="switchesList"
            item-key="SwitchId"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading switches list..."
            :single-select="true"
            :calculate-widths="true"
            @click:row="editSwitch"
            class="searchResults"
            dense
          >
            <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item, value }">
              {{ formatTableEl(item, value, header.format) }}
            </template>
            <template v-slot:[`item.SwitchDate`]="{ item }">
              <span>{{ displayDate(new Date(item.SwitchDate)) }}</span>
            </template>
          </v-data-table>

          <v-navigation-drawer
            v-if="isSidebarShown"
            fixed
            temporary
            right
            :width="sidebarWidth"
            stateless
            :value="isSidebarShown"
          >
            <v-container class="sidebar">
              <h3>Edit Switch Details</h3>

              <v-form ref="form" v-model="isFormValid" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <div class="formPanel">
                      <v-select
                        label="Sell Manager"
                        v-model="selectedSwitch.ManagerId"
                        :items="managerList"
                        item-value="ManagerId"
                        item-text="ManagerName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Sell Fund"
                        v-model="selectedSwitch.SellFundId"
                        :items="selectedSellManagerFundList"
                        item-value="PortfolioId"
                        item-text="PortfolioName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Buy Manager"
                        :items="managerList"
                        v-model="selectedSwitch.BuyManagerId"
                        item-value="ManagerId"
                        item-text="ManagerName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>

                      <v-select
                        label="Buy Fund"
                        :items="selectedBuyManagerFundList"
                        v-model="selectedSwitch.BuyFundId"
                        item-value="PortfolioId"
                        item-text="PortfolioName"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>
                      <v-select
                        label="Switch Type"
                        v-model="selectedSwitch.SwitchType"
                        :items="switchTypesList"
                        :rules="[(v) => !!v || 'Required']"
                        required
                      ></v-select>
                      <v-text-field
                        type="number"
                        label="Units Sold"
                        v-model="selectedSwitch.UnitsSold"
                      ></v-text-field>
                      <v-text-field
                        type="number"
                        label="Cash Held"
                        v-model="selectedSwitch.CashHeld"
                      ></v-text-field>
                      <DatePicker
                        label="Switch Date"
                        v-model="selectedSwitch.SwitchDate"
                      ></DatePicker>
                      <v-text-field
                        label="Switch Status"
                        v-model="selectedSwitch.SwitchStatus"
                      ></v-text-field>
                      <v-text-field
                        type="number"
                        label="Switch Amount"
                        v-model="selectedSwitch.SwitchAmount"
                      ></v-text-field>
                      <v-text-field
                        label="Switch Source"
                        v-model="selectedSwitch.Source"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-form>

              <div class="btnsContainer">
                <div>
                  <v-btn outlined color="error" @click="onDelete">Delete</v-btn>
                </div>
                <div>
                  <v-btn outlined color="primary" @click="cancelChanges" class="ml-4">Cancel</v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    @click="saveChanges"
                    class="ml-4"
                    :disabled="!isFormValid"
                    >Save</v-btn
                  >
                </div>
              </div>
            </v-container>
          </v-navigation-drawer>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  components: {
    Dialog,
    DatePicker,
  },
  name: 'Switches',

  data() {
    return {
      loading: false,
      isSidebarShown: false,
      sidebarName: 'switch',
      sidebarWidth: 475,
      managerList: [],
      formElements: [],
      allElements: [],
      headers: [],
      switchesList: [],
      selectedSellManagerFundList: [],
      selectedBuyManagerFundList: [],
      selectedSwitch: null,
      isFormValid: false,
      switchTypesList: ['%', 'Units', 'Value'],
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedSwitch) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    buyManagerId() {
      return this.selectedSwitch && this.selectedSwitch.BuyManagerId;
    },
    sellManagerId() {
      return this.selectedSwitch && this.selectedSwitch.ManagerId;
    },
    editDisabled() {
      return ['ManagerName', 'FundName', 'ContributionType', 'InvestmentType'];
    },
    showSidebar() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getSwitchesList();
    },
    buyManagerId(value) {
      if (value) {
        this.getFundList(value, 'buy');
      } else {
        this.selectedBuyManagerFundList = [];
      }
    },
    sellManagerId(value) {
      if (value) {
        this.getFundList(value, 'sell');
      } else {
        this.selectedSellManagerFundList = [];
      }
    },
  },

  created() {
    this.getHeaders('Switches');
  },

  mounted: function () {
    if (this.memberId) {
      this.getForm('Switches');
      this.$root.currentPage = 'Investments';
    } else {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    }

    this.getManagerList();
  },

  destroyed() {
    this.$root.currentPage = null;
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },
    editSwitch(item) {
      if (!this.showSidebar) return;
      this.isSidebarShown = true;
      if (item) {
        this.getSwitchById(item.SwitchId);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedSwitch = null;
      }
    },
    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedSwitch = null;
      this.selectedManagerFundList = [];
    },
    saveChanges() {
      if (this.isFormValid) {
        this.isSidebarShown = false;
        if (this.isNew) {
          this.addSwitch();
        } else {
          this.updateSwitch();
        }
      }
    },
    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteSwitch();
      } catch (err) {
        console.log();
      }
    },

    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },

    async addSwitch() {
      const newSwitch = { SwitchId: 0 };
      this.allElements.forEach((el) => {
        newSwitch[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newSwitch[el.FieldName] = el.Value;
      });
      newSwitch.SwitchId = 0;
      newSwitch.MembershipID = this.memberId;
      try {
        await this.$api.post('/Switch/UpdateSwitch', newSwitch);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Switch was added',
        });
        this.getSwitchesList();
      } catch (err) {
        console.log(err.message);
      }
    },
    async updateSwitch() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedSwitch[el.FieldName] = el.Value;
        });
        await this.$api.post('/Switch/UpdateSwitch', this.selectedSwitch);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Switch was updated',
        });
        this.getSwitchesList();
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },
    async deleteSwitch() {
      this.loading = true;
      try {
        await this.$api.delete('/Switch/DeleteSwitch?Id=' + this.selectedSwitch.SwitchId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Switch was deleted',
        });
        this.getSwitchesList();
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },
    async getSwitchesList() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/Switch/GetSwitchList?membershipId=' + this.memberId + '&orderBy=SwitchDate'
        );
        this.switchesList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async getSwitchById(id) {
      try {
        let response = await this.$api.get('/Switch/GetSwitch?Id=' + id);

        if (!response.data) {
          const msg = 'Can not find switch with id ' + id;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.selectedSwitch = response.data;
        var data = response.data;
        // match data with form fields
        //if (data) Utils.setDataToFormElements(data, this.formElements);
        //var m = this.formElements.find((element) => element.FieldId == 'BuyManagerId');
        //if (m) m.Value = m.Value.toString();
        if (data) this.selectedSwitch = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getFundList(managerId, type) {
      this.loading = true;
      try {
        const response = await this.$api.get('/Funds/GetFundList?managerId=' + managerId);

        if (type == 'buy') {
          this.selectedBuyManagerFundList = response.data;
          if (
            !this.selectedBuyManagerFundList.find(
              (f) => f.PortfolioId === this.selectedSwitch.BuyFundId
            )
          ) {
            this.selectedSwitch.BuyFundId = null;
          }
        } else {
          this.selectedSellManagerFundList = response.data;
          if (
            !this.selectedSellManagerFundList.find(
              (f) => f.PortfolioId === this.selectedSwitch.SellFundId
            )
          ) {
            this.selectedSwitch.SellFundId = null;
          }
        }

        /*if (this.formElements) {
          const fundIdField = this.formElements.find((el) => el.FieldName === 'FundId');
          fundIdField.LookupItems = [
            ...response.data.map((fund) => ({ Id: fund.PortfolioId, Text: fund.PortfolioName })),
          ];

          this.formElements = [...this.formElements];
        }*/
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getForm(formName) {
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=${formName}&planId=${this.currentPlanId}`
        );
        this.allElements = response.data;
        if (response.data.length)
          this.formElements = response.data.filter((f) => f.Visible == true);

        this.getSwitchesList();
      } catch (err) {
        console.error(err);
      }
    },
    async getHeaders(formName) {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=${formName}&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.switches {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}
.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.formPanel {
  margin-top: 5px;

  .v-input--checkbox,
  .v-input--radio-group--row {
    margin-top: 8px;
    margin-left: 5px;
    margin-bottom: 10px;
  }
  .v-input {
    max-width: 420px;
  }
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.btnsContainer > div {
  display: inline-block;
}
tbody > tr:hover {
  cursor: pointer;
}
</style>
